import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ef75491e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "first scroll-to" }

import StickyButton from "@/components/elements/ScrollButton.vue";
import Button from "@/components/elements/Button.vue";
import { createPopup } from "@typeform/embed";
import "@typeform/embed/build/css/popup.css";


export default /*#__PURE__*/_defineComponent({
  __name: 'ContactView',
  setup(__props) {

const { toggle } = createPopup("neB4Grmj");

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", null, [
        _createVNode(Button, {
          onClick: _unref(toggle),
          color: "black-400",
          size: "x-large",
          type: "ghost"
        }, {
          default: _withCtx(() => [
            _createTextVNode("CONTACT US")
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _createVNode(StickyButton)
  ]))
}
}

})